import { muiTheme } from "@/styles/theme";
import { Dispatch, Fragment, SetStateAction } from "react";
import SquareButton from "../../../ui/square-button";
import { Settings, Wrench } from "lucide-react";
import ColumnVisibilityDialog from "./visibility-dialog";
import { Table } from "@tanstack/react-table";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import CustomIconButton from "../../../ui/custom-icon-button";

export interface VisibilityButtonProps<TData> {
  visibility: boolean;
  setVisibility: Dispatch<SetStateAction<boolean>>;
  table: Table<TData>;
  defaultColumns?: string[];
}

export default function VisibilityButton<TData>({
  table,
  visibility,
  setVisibility,
  defaultColumns = [],
}: VisibilityButtonProps<TData>) {
  const { isMobile } = useScreenSize();

  return (
    <Fragment>
      {isMobile ? (
        <CustomIconButton
          handleClick={() => setVisibility((prev) => !prev)}
          icon={<Wrench size="16px" />}
        />
      ) : (
        <SquareButton
          variant="ghost"
          onClick={() => setVisibility((prev) => !prev)}
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: muiTheme.colorSchemes.light.palette.primary[500],
            width: "fit-content",
            padding: "4px 16px",
            gap: "8px",
          }}
        >
          <Settings size="16px" />
          Columns
        </SquareButton>
      )}

      <ColumnVisibilityDialog<TData>
        open={visibility}
        setOpen={setVisibility}
        table={table}
        defaultColumns={defaultColumns}
      />
    </Fragment>
  );
}
